import { Button } from "@/ui-components/ui/button";
import ConfirmationDialog from "@/ui-components/ui/confirmation-dialog";
import { Input } from "@/ui-components/ui/input";
import { Check, Copy, RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";

const ApiKeyManager = ({ apiKey, onRegenerate }: { apiKey: string; onRegenerate: () => void }) => {
  const [showCopyTooltip, setShowCopyTooltip] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      setTimeout(() => setCopied(false), 2000);
    }
  }, [copied]);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(apiKey);
    setCopied(true);
    setShowCopyTooltip(true);
    setTimeout(() => setShowCopyTooltip(false), 2000);
  };

  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-lg font-semibold">API-Token</h3>
      <div className="w-1/2 flex flex-col gap-2">
        <div className="relative">
          <Input
            value={apiKey}
            readOnly
            className="pr-10 font-mono cursor-pointer"
            onMouseEnter={() => setShowCopyTooltip(true)}
            onMouseLeave={() => setShowCopyTooltip(false)}
            onClick={handleCopy}
          />
          {showCopyTooltip && (
            <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-black text-white px-2 py-1 rounded text-sm">
              {copied ? "Kopiert" : "Klicken zum Kopieren"}
            </div>
          )}
          <Button
            variant="link"
            size="icon"
            className="absolute right-2 top-1/2 transform -translate-y-1/2"
            onClick={handleCopy}
          >
            {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          </Button>
        </div>

        <ConfirmationDialog
          title="API-Token neu generieren"
          description="Möchten Sie wirklich einen neuen API-Token generieren? Der alte Token wird dadurch ungültig."
          onConfirm={onRegenerate}
          variant="destructive"
        >
          <Button variant="outline" className="w-full flex items-center gap-2">
            <RefreshCw className="h-4 w-4" />
            Neuen Token generieren
          </Button>
        </ConfirmationDialog>
      </div>
    </div>
  );
};

export default ApiKeyManager;
